import React, { Component } from 'react';
import WizardStepOneForm from './wizardStepOne';
import WizardStepTwoForm from './wizardStepTwo';
import { greyScaleColors, semanticColors } from '../../Globals/styles'
import { connect } from 'react-redux';
import Radium from 'radium';
import * as actions from './actions'
import { reduxForm } from 'redux-form';

import auth from '../../Login/authService'

class CreateProjectWizard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isEdit: this.props.params.projectNumber ? true : false,
      page: 1
    }
  }
  componentWillMount = () => {
    if (this.state.isEdit) {
      this.props.dispatch(actions.attemptGetEditData(this.props.params.projectNumber));
    }
  };
  componentWillReceiveProps = (nextProps) => {
    if (this.props.params.projectNumber !== nextProps.params.projectNumber) {
      window.location.reload()
    }
  };
  componentWillUnmount = () => {
    this.props.dispatch(actions.submitFormSuccess());
    this.props.dispatch(this.props.destroyForm());
  };
  nextPage = () => {
    this.setState({ page: this.state.page + 1 });
  };
  previousPage = () => {
    this.setState({ page: this.state.page - 1 });
  };
  onSubmit = (values, dispatch) => {
    if (this.state.isEdit) {
      dispatch(actions.attemptEditForm());
    }
    else {
      //submit the form
      dispatch(actions.attemptSubmitForm());
    }

  };
  render() {
    const { dispatch, workplaceSuggestions, suggestions, projectNumberReserved,
      isFormSubmitting, rowShouldUpdate } = this.props;
    const prof = auth.getProfile();
    const user = {
      fullname: prof.name,
      authObject: {
        username: prof.username,
        role: prof.role
      }
    }
    return (
      <div style={styles.outerContainer}>
        <div style={styles.container}>
          <div className="container">


            {/*WIZARD NAV*/}
            <div style={styles.wizardNav}>
              <div style={[styles.wizardNavItem, styles.wizardNavItemActive]}>
                <span className="fa-stack fa-lg">
                  <i
                    style={[styles.wizardNavCircleActive, this.state.page === 2 && styles.wizardNavCircleSuccess]}
                    className="fa fa-circle fa-stack-2x" />
                  {this.state.page === 2 ? <i style={styles.check} className="fa fa-check fa-stack-1x fa-inverse" /> : null}
                </span>
                <div>{this.state.isEdit ? "SAG" : "OPRET SAG"}</div>
              </div>
              <i style={styles.wizardNavArrow} className="fa fa-arrow-right"></i>
              <div style={styles.wizardNavItem}>
                <span className="fa-stack fa-lg">
                  <i
                    style={[styles.wizardNavCircle, this.state.page === 2 && styles.wizardNavCircleActive, isFormSubmitting && styles.wizardNavCircleSuccess]}
                    className="fa fa-circle fa-stack-2x" />
                  {isFormSubmitting ? <i style={styles.check} className="fa fa-check fa-stack-1x fa-inverse" /> : null}
                </span>
                <div>AKTIVITETER</div>
              </div>
            </div>
            {/*WIZARD HEADER*/}
            <div style={styles.wizardHeader}>
              <h2 style={styles.h2}>{this.state.page === 1 || isFormSubmitting ? this.state.isEdit ? "Rediger sag" : "Opret sag" : "Aktiviteter"}</h2>
            </div>
            {/*WIZARD FORM*/}
            {/*WIZARD STEP ONE*/}
            {this.state.page === 1 && !isFormSubmitting && <WizardStepOneForm
              getWorkplaceSuggestions={(val) => dispatch(actions.getWorkplaceSuggestions(val))}
              getSuggestions={(val, suggestionsFor) => dispatch(actions.getSuggestions(val, suggestionsFor))}
              suggestions={suggestions}
              workplaceSuggestions={workplaceSuggestions}
              isProjectNumberReserved={(val) => dispatch(actions.isProjectNumberReserved(val))}
              projectNumberReserved={projectNumberReserved}
              getWorkplaceLocation={(val) => dispatch(actions.getWorkplaceLocation(val))}
              user={user}
              nextPage={this.nextPage}
              isEdit={this.state.isEdit}
            />}

            {/*WIZARD STEP TWO*/}
            {this.state.page === 2 && !isFormSubmitting && <WizardStepTwoForm
              onSubmit={this.onSubmit}
              previousPage={this.previousPage}
              setRowShouldUpdate={(rootKey, secondKey, thirdKey) => dispatch(actions.setRowShouldUpdate(rootKey, secondKey, thirdKey))}
              rowShouldUpdate={rowShouldUpdate}
              isEdit={this.state.isEdit}
            />}
            {/*If form is submitting render a spinner*/}
            {isFormSubmitting ?
              <div style={styles.spinnerContainer}>
                <div style={styles.spinner}> {this.state.isEdit ? "Gemmer ændringer..." : "Gemmer sag..."}
                  <div>
                    <i className="fa fa-spinner fa-spin fa-3x" />
                  </div>
                </div>
              </div>
              : null}
          </div>
        </div>
      </div>
    );
  }
}


var styles = {
  outerContainer: {
    minHeight: '100%',
    width: '100%',
    backgroundColor: greyScaleColors.greyLighter
  },
  wizardNav: {
    height: '80px',
    textAlign: 'center',
    position: 'relative'
  },
  wizardNavItem: {
    display: 'inline-block',
    marginTop: '13px',
    fontWeight: '600',
    padding: '0 12px',
    minWidth: '100px'
  },
  wizardNavCircle: {
    color: greyScaleColors.greyLight
  },
  wizardNavCircleActive: {
    color: semanticColors.info
  },
  wizardNavCircleSuccess: {
    color: semanticColors.success
  },
  check: {
    color: '#fff'
  },
  wizardNavArrow: {
    fontSize: '18px',
    position: 'absolute',
    top: '23px',
    left: '50%',
    marginLeft: '-10px'
  },
  wizardHeader: {
    height: '34px',
    backgroundColor: semanticColors.primary,
    paddingLeft: '12px',
    borderRadius: '2px'
  },
  h2: {
    color: '#fff',
    lineHeight: '34px'
  },
  spinnerContainer: {
    width: '100%',
    height: '100%'
  },
  spinner: {
    width: '180px',
    textAlign: 'center',
    marginLeft: 'auto',
    marginRight: 'auto',
    marginTop: '25%',
    fontWeight: '600',
    fontSize: '16px',
    lineHeight: '35px'
  }
}


var w = Radium(CreateProjectWizard)
//connect to redux form to get formDestroy method
var CreateProjectWizardForm = reduxForm(
  {
    form: 'createProjectWizard',
    fields: [
      'projectName',
      'projectNumber',
      'client',
      'address',
      'contacts[].id',
      'contacts[].title',
      'contacts[].name',
      'contacts[].email',
      'contacts[].telephone',
      'employees[]',
      'mon',
      'tue',
      'wed',
      'thu',
      'fri',
      'sat',
      'sun',
      'rootActivities[].id',
      'rootActivities[].name',
      'rootActivities[].seconds[].id',
      'rootActivities[].seconds[].name',
      'rootActivities[].seconds[].unit',
      'rootActivities[].seconds[].amount',
      'rootActivities[].seconds[].hoursPerUnit',
      'rootActivities[].seconds[].sum',
      'rootActivities[].seconds[].thirds[].id',
      'rootActivities[].seconds[].thirds[].name',
      'rootActivities[].seconds[].thirds[].unit',
      'rootActivities[].seconds[].thirds[].amount',
      'rootActivities[].seconds[].thirds[].hoursPerUnit',
      'rootActivities[].seconds[].thirds[].sum'
    ]
  },
  state => ({ // mapStateToProps
    initialValues: state.projectFormReducer.data // will pull state into form's initialValues
  })
)(w);

function selectProps(state) {
  return {
    ...state.projectFormReducer,
    destroyForm: state.form.createProjectWizard ? state.form.createProjectWizard.destroyForm : null
  };
}

export default connect(selectProps)(CreateProjectWizardForm);


// WEBPACK FOOTER //
// ./src/App/Project/CreateProject/index.jsx